var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelop = function SvgEnvelop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    "aria-hidden": "true",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383c42",
    d: "M40 20C40 8.962 31.038 0 20 0S0 8.962 0 20s8.962 20 20 20 20-8.961 20-20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M29.03 11.456H10.967a3.01 3.01 0 0 0-3.01 3.01v12.04a3.01 3.01 0 0 0 3.01 3.01H29.03a3.01 3.01 0 0 0 3.01-3.01v-12.04c0-1.662-1.35-3.01-3.01-3.01m-18.063 2.258H29.03c.415 0 .753.337.753.752v1.043l-7.846 6.495c-1.091.906-2.792.906-3.88 0l-7.842-6.494v-1.044c0-.414.338-.752.752-.752M29.03 27.259H10.967a.754.754 0 0 1-.752-.753V18.45l6.402 5.333a5.306 5.306 0 0 0 6.767-.004l6.399-5.329v8.056a.755.755 0 0 1-.753.753"
  })));
};
export default SvgEnvelop;